import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { ErrorPage, EscrowTimer, EventWrapper } from '@components';
import { ALLOWED_PATHS_AFTER_PAYMENT, DATE_FORMAT_SHORT } from '@constants';
import { /* initialTicketState, */ useAppContext } from '@contexts';
import { typechecker } from '@utils';
import { handleRenderError, withErrorHandler } from '@utils/errorHandler';

import { CtaContainer } from '../CtaContainer';

interface ICheckoutWrapperProperties {
  blocked?: boolean;
  buttonText?: string;
  children?: any;
  loading?: boolean;
  muted?: boolean;
  isFinal?: boolean;
  onButtonClick?: (event: any) => void;
  stepClass?: string;
}

export const CheckoutWrapper = ({
  blocked,
  buttonText,
  children,
  isFinal,
  loading,
  muted,
  onButtonClick,
  stepClass,
}: ICheckoutWrapperProperties) => {
  try {
    const { event, eventSeries, escrowExpiryTime, isPaymentCompleted } =
      useAppContext();
    const router = useRouter();
    const { pathname } = router;

    useEffect(() => {
      if (window === undefined) {
        return;
      }
      // Enforce after payment paths
      if (
        isPaymentCompleted &&
        !ALLOWED_PATHS_AFTER_PAYMENT.includes(pathname)
      ) {
        router.replace(
          `/event/${event.ID || eventSeries?.ID}/checkout/contact`
        );
      }
    });

    return typechecker.isEvent(event) ? (
      <EventWrapper event={event} eventSeries={eventSeries}>
        <div className='appCheckout active'>
          <div className='appCheckoutContainer'>
            <div className='appCheckoutEventOverview'>
              <div className='appCheckoutEventOverviewImage'>
                <img
                  alt='Event Background'
                  src={eventSeries?.Background ?? event.Background}
                />
              </div>
              <div className='appCheckoutEventOverviewText'>
                <h1>{event.Name === '' ? eventSeries?.Name : event.Name}</h1>
                <h3>
                  {event.VenueName ?? eventSeries?.VenueName ?? ''}
                  {pathname !== '/event/[eventId]/checkout/date-select' &&
                    event.Date && (
                      <>
                        &nbsp;•&nbsp;{' '}
                        {dayjs(event.Date).format(DATE_FORMAT_SHORT)}
                      </>
                    )}
                </h3>
              </div>
              {escrowExpiryTime && !isPaymentCompleted && <EscrowTimer />}
            </div>
            <hr className='appCheckoutCardTopLine'></hr>
            <div className={`appCheckoutCard${isFinal ? ' final' : ''}`}>
              <div
                className={`appCheckoutStep active${
                  stepClass ? ` ${stepClass}` : ''
                }`}
              >
                {children}

                {buttonText && (
                  <CtaContainer
                    blocked={blocked}
                    buttonText={buttonText}
                    muted={muted}
                    loading={loading}
                    onButtonClick={
                      onButtonClick && withErrorHandler(onButtonClick)
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </EventWrapper>
    ) : (
      <ErrorPage />
    );
  } catch (error) {
    return handleRenderError(error);
  }
};
